module.exports = __webpack_public_path__ + "img/tarjeta.ac23e828.png";